import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import Typography from '@material-ui/core/Typography'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
// FIXME: esta información hay que sacarla desde el archivo de routes
const breadcrumbDictionary = {
  'maestro-datos': ['Gestión de autos', 'Listado'],
  'maestro-datos/editar': ['Gestión de autos', 'Listado / Editar'],
  'maestro-datos/crear': ['Gestión de autos', 'Listado / Crear'],
  'maestro-datos/ver': ['Gestión de autos', 'Listado / Ver'],
  'main-comparador': 'Comparador',
  'car-catalogo': 'Producto',
  stock: 'Stock',
  'vista-vendedor': 'Vista Vendedor',
  comparador: 'Comparador',
  peritador: 'Peritador',
  presupuestador: 'Presupuestador',
  'solicitud-venta': 'Solicitud de Venta',
  edit: 'Editar',
  carDetail: 'Detalle de vehículo',
  planDetail: 'Detalle de producto',
  editar: 'Editar',
  crear: 'Crear',
  ver: 'Ver',
  campania: 'Campaña',
  usuarios: ['Gestión de cuentas', 'Usuarios'],
  'usuarios/listado': ['Gestión de cuentas', 'Usuarios / Listado'],
  'usuarios/crear': ['Gestión de cuentas', 'Usuarios / Nuevo'],
  'usuarios/editar': ['Gestión de cuentas', 'Usuarios / Editar'],
  'usuarios/confirmar': ['Gestión de cuentas', 'Usuarios / Confirmar'],
  'usuarios/editar-usuario': ['Mi perfil'],
  perfiles: ['Gestión de cuentas', 'Perfiles'],
  'perfiles/nuevo-perfil': ['Gestión de cuentas', 'Perfiles / Nuevo'],
  'perfiles/editar': ['Gestión de cuentas', 'Perfiles / Editar'],
  'perfiles/duplicar': ['Gestión de cuentas', 'Perfiles / Duplicar'],
  'simulador-financiero/alta-de-linea': ['Líneas financieras', 'Alta de línea'],
  savingPlan: 'Plan de ahorro',
  detalleDelLead: 'Detalle del lead',
  'cotizador/nueva': ['Cotizador', 'Nueva cotización'],
  'cotizador/resultado': ['Cotizador', 'Resultado de cotización'],
}

const primaryMenuBlackList = [
  breadcrumbDictionary.presupuestador,
];

// Este array se usa como excepcion para no reemplazar por el id de la ruta si es que tiene
const secondaryMenuBlackList = [
  breadcrumbDictionary.ver,
  breadcrumbDictionary.editar,
  breadcrumbDictionary.detalleDelLead,
  breadcrumbDictionary.planDetail,
  breadcrumbDictionary.savingPlan,
];

// Como la ruta está atada al breadcrumb y por el impacto no podemos reemplazar la ruta, aqui se detallan
// breadcrumbs especificos que tienen que ser reemplazados para no depender de la ruta por la que fueron definidos
// DT para refactorizar esta dependencia ID-87782
const replaceSecondaryBreadcrumbsException = 
  { 
    'gestor-leads': {'editar':breadcrumbDictionary.detalleDelLead}
  }

// @see src\features\common\Utilities.js -> updateBreadcrumbs
const BreadcrumbLabel = ({ value, color }) => {
  return <Typography color={color}>{value}</Typography>
}

export class NavBreadcrumbs extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      primaryMenu: null,
      secondaryMenu: null,
      primaryPathName: null,
      secondaryPathName: null,
      detailPathName: null
    }
  }
  componentDidMount() {
    this.buildPathNames()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location?.state?.breadcrumbs !== this.props.location?.state?.breadcrumbs
    ) {
      this.buildPathNames()
    }
  }

  buildPathNames = () => {
    const menuItems = this.props.user.system
    const locationPathNames = this.props.location.pathname
      .split('/')
      .filter(x => x)
      let primaryMenu
      let primaryPathName
      let secondaryPathName
      let detailPathName
      const breadcrumbsValues = this.forceUpdateSecondaryBreadcrumbs(locationPathNames)
      secondaryPathName = breadcrumbsValues.secondaryPathName
      if (locationPathNames && locationPathNames.length > 1) {
        // First, check if there is a navItemSlug avaiable
        const navItemSlug = locationPathNames.join('/')
        menuItems.forEach(menuItem => {
          if (menuItem.content) {
            const navItem = menuItem.content.find(
              nvItm => nvItm.slug === navItemSlug
              )
              if (navItem) {
            primaryMenu = menuItem
            primaryPathName = menuItem.name
            secondaryPathName = navItem.name
            locationPathNames.splice(0, 2)
          }
        }
      })
      const pathFromDictionary = breadcrumbDictionary[navItemSlug]
      if (pathFromDictionary && pathFromDictionary instanceof Array) {
        primaryPathName = pathFromDictionary[0]
        secondaryPathName = pathFromDictionary[1]
        locationPathNames.splice(0, 2)
      }
    }
    locationPathNames.forEach(locationPathName => {
      if (!primaryPathName) {
        // If it is the first iterations (doesn't have primaryPathName yet)
        // Searches the locationPathName in the menuItems array
        const menuItem = menuItems?.find(menu => menu.slug === locationPathName)
        if (menuItem) {
          primaryMenu = menuItem
          primaryPathName = menuItem.name
        } else {
          // Check if there is an exception on the dictionary for the first pathName
          const pathFromDictionary = breadcrumbDictionary[locationPathName]
          if (pathFromDictionary && pathFromDictionary instanceof Array) {
            primaryPathName = pathFromDictionary[0]
            secondaryPathName = pathFromDictionary[1]
          } else {
            primaryPathName = this.getPathName(locationPathName)
          }
        }
      } else if (!secondaryPathName) {
        // Validates if there is a primaryMenu, so then, the secondaryPathName can be found
        // in the content array of the primaryMenu
        if (primaryMenu) {
          const fullPathName = `${primaryMenu.slug}/${locationPathName}`
          const subMenuItem = primaryMenu.content?.find(subMenu => {
            return subMenu.slug === fullPathName
          })
          if (subMenuItem) {
            secondaryPathName = subMenuItem.name
          } else {
            secondaryPathName = this.getPathName(locationPathName)
          }
        } else {
          secondaryPathName = this.getPathName(locationPathName)
        }
      } else if(!primaryMenuBlackList.includes(primaryMenu) && !secondaryMenuBlackList.includes(secondaryPathName)) {
        detailPathName = this.getPathName(locationPathName)
      }
    })

    this.setState({
      primaryMenu,
      primaryPathName,
      secondaryPathName,
      detailPathName
    })
  }

  forceUpdateSecondaryBreadcrumbs(locationPathNames) {
    const breadcrumbExceptionKeys = Object.keys(replaceSecondaryBreadcrumbsException)
    let secondaryPathName
    if (breadcrumbExceptionKeys.includes(locationPathNames[0])) {
      secondaryPathName = replaceSecondaryBreadcrumbsException[locationPathNames[0]][locationPathNames[1]]
    }
    return {
      secondaryPathName: secondaryPathName
    }
  }

  getPathName = (path = '') => {
    // Checck if the path is either in the bradCrumDictionary or the location.state
    const mappedValue =
      breadcrumbDictionary[path] ||
      this.props.location.state?.breadcrumbs?.[path]
    if (mappedValue) {
      const mappedValueWithoutNull = mappedValue.replace(/null/gi, '')
      return mappedValueWithoutNull
    } else {
      // Format path value to a legible name
      const pathWithoutDash = path.replace(/-/g, ' ')
      const pathWithoutNull = pathWithoutDash.replace(/null/gi, '')
      const pathCapitalized =
        pathWithoutNull.charAt(0).toUpperCase() + pathWithoutDash.slice(1)
      return pathCapitalized
    }
  }

  render() {
    return (
      <div className="home-nav-breadcrumbs">
        <Breadcrumbs aria-label="breadcrumb" className="header-nav-breadcrumb">
          <BreadcrumbLabel value={this.state.primaryPathName} color="primary" />
          {this.state.secondaryPathName && (
            <BreadcrumbLabel
              value={this.state.secondaryPathName}
              color="textPrimary"
            />
          )}
          {this.state.detailPathName && (
            <BreadcrumbLabel
              value={this.state.detailPathName}
              color="textPrimary"
            />
          )}
        </Breadcrumbs>
      </div>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.common.user,
    home: state.home,
    location: state.router.location
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBreadcrumbs)
